import { Scrollbar } from './scrollbar';
/**
 * ScrollbarX component.
 */
export const ScrollbarX = (options) => {
    return Scrollbar(Object.assign(Object.assign({}, options), { orientation: 'horizontal' }));
};
ScrollbarX.props = Object.assign(Object.assign({}, Scrollbar.props), { defaultPosition: 'bottom' });
//# sourceMappingURL=scrollbarX.js.map